/*global ViewController, WebView*/

var mainController = new ViewController({
    directory : "views/welcome",
    name: "welcome",
    container: "welcome",
    route: "" //displayed by default
}) ;


function toRadians (angle) {
    return angle * (Math.PI / 180);
  }

mainController.prepareDataOnEnter = function(data, callback){
    var petals = [] ;
    var user = this.api.currentUser||{rights:{}} ;
    var countHasRight = 0 ;
    var modules = ["contract", "sale", "prod", "stock", "purchase", "bill", "pay", "account", "paper", "doc"] ;
    modules.forEach(function(m, i){
        var angle = (360/modules.length) *i ;

        var distanceToCenter = 24;
        var petalW = 16;
        
        var distanceToCenterVertical = Math.sin(toRadians(90-angle))*distanceToCenter ;
        var distanceToCenterHoriz = Math.sin(toRadians(angle))*distanceToCenter ;
        
        distanceToCenterHoriz = distanceToCenterHoriz - (petalW/2) ;
        var sign = distanceToCenterHoriz>=0?"+":"-" ;
        distanceToCenterHoriz = Math.abs(distanceToCenterHoriz) ;
        
        var top = "calc(50% - "+(distanceToCenterVertical+(petalW/2))+"vh)";
        var left = "calc(50% "+sign+" "+distanceToCenterHoriz+"vh)";
        
        //FIXME
        //m.classColor = "petal-color-"+m.color ;
        
        petals.push({
            code: m,
            top: top,
            left: left,
            angle: angle,
            label: WebView.tr(m+".menu"),
            hasRight: user.rights["group_iz_"+m+"_module_user"]
        }) ;
    })  ;  
    data = {
        petals: petals
    } ;
    callback(null, data) ;
} ;

module.exports = mainController ;